module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Icons Page\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1458d642!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ui-elements/Icons.vue
// module id = 495
// module chunks = 1